import {isNil} from "lodash";
import moment from "moment";
import {Milliseconds} from "../../constans/milliseconds";
import {isFiniteNumber} from "../../utils/MathUtils";

export default class TimestampChecker {
    constructor(options) {
        this._invalidateTime = isFiniteNumber(options?.invalidateTime)
            ? options.invalidateTime
            : Milliseconds.MINUTE * 5;
        this._requested = {};
    }

    /**
     * metoda sprawdza czy dane z okresu są już pobrane lub pytalismy o nie i nie dostalismy odpowiedzi
     * @param aggregatedData
     * @param startUTC
     * @param endUTC
     * @returns {boolean}
     */
    alreadyFetched(aggregatedData, startUTC, endUTC) {
        const shouldHaveTheseTimestamps = this._generateTimestamps(
            startUTC,
            endUTC
        );
        let hasData = true;
        const now = Date.now();
        for (let timestamp of shouldHaveTheseTimestamps) {
            this._fix(timestamp, now);
            if (this._get(timestamp)) continue;
            if (!aggregatedData.find((item) => item.AggTi === timestamp)) {
                hasData = false;
                break;
            }
        }
        return hasData;
    }

    /**
     * metoda ustawia dany okres danych jako pobrane
     * @param start
     * @param end
     */
    markAsFetched = (start, end, exactDatesOnly = false) => {
        const now = Date.now();
        if (exactDatesOnly) {
            this._set(+start, now);
            this._set(+end, now);
            return;
        }
        const timestamps = this._generateTimestamps(start, end);
        timestamps.forEach((timestamp) => {
            this._set(timestamp, now);
        });
    };

    _fix(timestamp, now = Date.now()) {
        const diff = now - this._get(timestamp);
        if (diff > this._invalidateTime) {
            this._clear(timestamp);
        }
    }

    _get(timestamp) {
        return this._requested[timestamp] || 0;
    }

    _clear(timestamp) {
        delete this._requested[timestamp];
    }

    _set(timestamp, setAt) {
        this._requested[timestamp] = setAt;
    }

    _generateTimestamps(startUTC, endUTC) {
        return isNil(endUTC)
            ? [startUTC]
            : new Array(
                  Math.abs(
                      moment.utc(startUTC).diff(moment.utc(endUTC), "day")
                  ) + 1
              )
                  .fill(0)
                  .map((o, i) => {
                      return Math.min(endUTC, startUTC) + i * Milliseconds.DAY;
                  });
    }
}
